import _defineProperty from "/Users/sokol/workspace/zegluj/widget/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import speedometer from "./speedometer.js";
import throttle from "./throttle.js";
import utils from "../utils.js";
export var progressEventReducer = function progressEventReducer(listener, isDownloadStream) {
  var freq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var bytesNotified = 0;

  var _speedometer = speedometer(50, 250);

  return throttle(function (e) {
    var loaded = e.loaded;
    var total = e.lengthComputable ? e.total : undefined;
    var progressBytes = loaded - bytesNotified;

    var rate = _speedometer(progressBytes);

    var inRange = loaded <= total;
    bytesNotified = loaded;

    var data = _defineProperty({
      loaded: loaded,
      total: total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null
    }, isDownloadStream ? 'download' : 'upload', true);

    listener(data);
  }, freq);
};
export var progressEventDecorator = function progressEventDecorator(total, throttled) {
  var lengthComputable = total != null;
  return [function (loaded) {
    return throttled[0]({
      lengthComputable: lengthComputable,
      total: total,
      loaded: loaded
    });
  }, throttled[1]];
};
export var asyncDecorator = function asyncDecorator(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return utils.asap(function () {
      return fn.apply(void 0, args);
    });
  };
};